import React, { useEffect, useContext, useRef } from 'react'

import { EmpresasContext } from '../../../contexts/EmpresasContext'

import { Grid, Typography, Chip, Box } from '@mui/material'

import Lottie from 'lottie-react'
import { checkAnimated } from '../../../assets'
import WhatshotIcon from '@mui/icons-material/Whatshot'
import { PiSealPercentFill } from 'react-icons/pi'
import RouterHook from '../../../contexts/RouterHook'
import { ToastMessages } from '../../ToastMessages'
import { formatHorario, status } from './functions'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'

export default function ButtonHorario({ horario, disabled, onChange, isSelected, isNobre = false, reagendavel = false }) {
  const serverRouter = RouterHook()
  const { sttPg } = useContext(EmpresasContext)
  const { sttCtxAgend } = useContext(AgendamentoContext)

  const formattedHorario = formatHorario(horario)

  const handleClick = () => {
    const newIsChecked = !isSelected
    onChange(newIsChecked)
  }
  const avoidDetalhesAgendamentoWhenRescheduling = () => {
    ToastMessages.cannotOpenDetailsWhileRescheduling()
  }

  function detalhesPedido() {
    if (Object.keys(sttCtxAgend.reagendamento).length === 0) {
      serverRouter('agendamento', horario.idpedido)
    } else {
      avoidDetalhesAgendamentoWhenRescheduling()
    }
  }

  const lottieRef = useRef(null)
  useEffect(() => {
    const interval = setInterval(() => {
      if (lottieRef.current) {
        lottieRef.current.setSpeed(4)
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [isSelected])

  const solicitei = (horario.status === 'AGENDADO' || horario.status === 'SOLICITADO') && disabled === 'agendei'

  return (
    <button
      className={`tw-w-full ${horario.valorPromocional ? 'tw-h-12' : 'tw-h-9'} tw-mt-1`}
      onClick={!reagendavel ? (!solicitei ? handleClick : detalhesPedido) : null}
      disabled={disabled === 'invalido' || (solicitei && sttPg.selectedHorarios.length > 0)}
    >
      <Box
        sx={{
          bgcolor: `${
            solicitei ? (!reagendavel ? (horario.status === 'SOLICITADO' ? '#fcd0c2' : '#bce3c4') : 'rgba(255, 174, 25, 0.3)') : 'background.paper'
          }`,
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          opacity: `${(solicitei && sttPg.selectedHorarios.length > 0) || disabled === 'invalido' ? 0.5 : 1}`,
          ...(reagendavel && {
            opacity: 0.7,
            transform: 'scale(0.95)',
          }),
        }}
      >
        <Grid container spacing={0} alignItems='center'>
          <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
            {isSelected && <Lottie animationData={checkAnimated} loop={false} style={{ width: '22 px', height: '22px' }} lottieRef={lottieRef} />}
          </Grid>
          <Grid item xs={4}>
            <Typography variant='body2' fontWeight='bold' align='left'>
              {formattedHorario}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            {isNobre && horario.promocao ? (
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, justifyContent: 'center' }}>
                <Chip
                  label={<WhatshotIcon color='gold' fontSize='small' />}
                  size='small'
                  sx={{ backgroundColor: 'gold.fadedGold', color: 'gold.main', fontWeight: 'bold' }}
                />
                <Chip
                  label={<PiSealPercentFill color='success.green' fontSize='large' />}
                  size='small'
                  sx={{ backgroundColor: 'success.lightGreen', color: 'success.green', fontWeight: 'bold' }}
                />
              </Box>
            ) : isNobre ? (
              <Chip
                label='Nobre'
                size='small'
                sx={{ backgroundColor: 'gold.fadedGold', color: 'gold.main', fontWeight: 'bold' }}
                icon={<WhatshotIcon color='gold' fontSize='small' />}
              />
            ) : (
              horario.promocao && (
                <Chip
                  label='Promoção'
                  size='small'
                  sx={{ backgroundColor: 'success.lightGreen', color: 'success.green', fontWeight: 'bold' }}
                  icon={<PiSealPercentFill color='success.green' />}
                />
              )
            )}
          </Grid>
          <Grid item xs={3}>
            {status(horario, solicitei, reagendavel)}
          </Grid>
        </Grid>
      </Box>
    </button>
  )
}
